import { render, staticRenderFns } from "./api-document.vue?vue&type=template&id=04c5252a&scoped=true&"
import script from "./api-document.vue?vue&type=script&lang=js&"
export * from "./api-document.vue?vue&type=script&lang=js&"
import style0 from "./api-document.vue?vue&type=style&index=0&id=04c5252a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c5252a",
  null
  
)

export default component.exports